import axios from 'axios'

const instace = axios.create({
  baseURL: process.env.REACT_APP_API_ORGANIZACAO_URL,
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
})

instace.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  },
  error => Promise.reject(error)
)

async function syncLeitor(cpf) {
  try {
    const response = await instace.post(
      `/colaboradores/${cpf}/publish-event`,
      {}
    )
    return response
  } catch (err) {
    console.log(err)
    throw new Error(err.message)
  }
}

export default syncLeitor
